import { Box, Button, useMediaQuery, IconButton, Typography, useTheme } from "@mui/material";
import { tokens } from "../../theme";
import { useEffect, useState } from "react";
import { collection, query, orderBy, limit, onSnapshot, where } from "firebase/firestore";
import {db} from "../../firebaseConfig";
import DownloadOutlinedIcon from "@mui/icons-material/DownloadOutlined";
import BadgeOutlinedIcon from "@mui/icons-material/BadgeOutlined";
import BuildOutlinedIcon from "@mui/icons-material/BuildOutlined";
import WalletOutlinedIcon from "@mui/icons-material/WalletOutlined";
import PaymentsOutlinedIcon from "@mui/icons-material/PaymentsOutlined";
import Header from "../../components/Header";
import LineChart from "../../components/LineChart";
//import GeographyChart from "../../components/GeographyChart";

import FunnelChart from "../../components/FunnelChart";

import BarChart from "../../components/BarChart";
import StatBox from "../../components/StatBox";
import ProgressCircle from "../../components/ProgressCircle";

import backgroundImage from './../../images/application-bg-images/app-bg-image.png';
import backgroundImageMobile from './../../images/application-bg-images/app-bg-image-mobile.png';

import { useUser } from "../../common/UserContext";
import { useApplicationMode } from "../../common/ApplicationModeContext";

const convertFirestoreTimestampToDateString = (timestamp) => {
  if (timestamp != null && timestamp !== "") {
    // Convert the seconds since Unix epoch to a Date object
    const date = new Date(timestamp.seconds * 1000);

    // Extract month, day, and year
    const month = (date.getMonth() + 1).toString().padStart(2, '0');
    const day = (date.getDate()+1).toString().padStart(2, '0');
    const year = date.getFullYear();

    // Format as "mm/dd/yyyy"
    return `${month}/${day}/${year}`;
  } else {
    return "";
  }
};


const Dashboard = () => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  const [outofStockProductsTotalFirstTopTile, setOutofStockProductsTotalFirstTopTile] = useState(0);
  const [outofStockProductsFirstTopTile, setOutofStockProductsFirstTopTile] = useState(0);
  const [pendingSalesOrdersSecondTopTile, setPendingSalesOrdersSecondTopTile] = useState(0);
  const [pendingSalesOrdersTotalSecondTopTile, setPendingSalesOrdersTotalSecondTopTile] = useState(0);

  const [activeStorageLocationsThirdTopTile, setActiveStorageLocationsThirdTopTile] = useState(0);
  const [activeStorageLocationsTotalThirdTopTile, setActiveStorageLocationsTotalThirdTopTile] = useState(0);
  const [grainIngredientsFourthTopTile, setGrainIngredientsFourthTopTile] = useState(0);
  const [grainIngredientsTotalFourthTopTile, setGrainIngredientsTotalFourthTopTile] = useState(0);

  const [lineChartData, setLineChartData] = useState([]);
  const [totalLineChartSum, setTotalLineChartSum] = useState(0);
  const [recentTransactions, setRecentTransactions] = useState([]);

  const [funnelChartData, setFunnelChartData] = useState([]);

  const [pendingProductionBatchesTotalProgressCircle, setPendingProductionBatchesTotalProgressCircle] = useState(0);
  const [pendingProductionBatchesProgressCircle, setPendingProductionBatchesProgressCircle] = useState(0);
  const [progressPercentage, setProgressPercentage] = useState(0);

  const [barChartData, setBarChartData] = useState([]);

  const { appUserAccountNumber } = useUser();
  const { applicationMode } = useApplicationMode(); 

  useEffect(() => {

    const funnelChartCollection  = query(collection(db, "salesOrders"), where("appAccountNumber", "==", appUserAccountNumber),where("applicationMode", "==", applicationMode));
    const progressCircleCollection  = query(collection(db, "productionBatches"), where("appAccountNumber", "==", appUserAccountNumber),where("applicationMode", "==", applicationMode));
    const barChartCollection  = query(collection(db, "salesOrders"), where("appAccountNumber", "==", appUserAccountNumber),where("applicationMode", "==", applicationMode));
    const firstTopTileCollection = query(collection(db, "products"), where("appAccountNumber", "==", appUserAccountNumber),where("applicationMode", "==", applicationMode));
    const secondTopTileCollection = query(collection(db, "salesOrders"), where("appAccountNumber", "==", appUserAccountNumber),where("applicationMode", "==", applicationMode));
    const thirdTopTileCollection = query(collection(db, "storageLocations"), where("appAccountNumber", "==", appUserAccountNumber),where("applicationMode", "==", applicationMode));
    const fourthTopTileCollection = query(collection(db, "ingredients"), where("appAccountNumber", "==", appUserAccountNumber),where("applicationMode", "==", applicationMode));
    const lineChartCollection = query(collection(db, "salesOrders"), where("appAccountNumber", "==", appUserAccountNumber),where("applicationMode", "==", applicationMode));
    const recentTransactionQuery = query(
      collection(db, "ingredients"),
      where("appAccountNumber", "==", appUserAccountNumber),
      where("applicationMode", "==", applicationMode),
      orderBy("expiryDate", "desc"),
      limit(8)
    );

  

    const unsubscribeFirstTopTileData = onSnapshot(firstTopTileCollection, snapshot => {
      let total = 0;
      
      snapshot.forEach(doc => {
        total += 1; // Aggregate billAccounts count
      });
      
      let categoryTotal = snapshot.docs.filter((doc) => doc.data().availability === "Out of Stock").length;

      setOutofStockProductsTotalFirstTopTile(total);

      setOutofStockProductsFirstTopTile(categoryTotal);

    });


    const unsubscribeProgressCircleData = onSnapshot(progressCircleCollection, snapshot => {
      let total = 0;
      snapshot.forEach(doc => {
        total += 1; // Aggregate tasks count
      });
      setPendingProductionBatchesTotalProgressCircle(total);

      let items = snapshot.docs.filter((doc) => doc.data().qualityControlStatus === "Pending").length;
      setPendingProductionBatchesProgressCircle(items);

     let progressPercentageVar = 0;

      if (total > 0)
      {
        progressPercentageVar = items / total;

      }
     
     
      setProgressPercentage(progressPercentageVar);

    });

    const unsubscribeSecondTopTileData = onSnapshot(secondTopTileCollection, snapshot => {
      let total = 0;
      let categoryTotal = 0;

      snapshot.forEach(doc => {
        total += doc.data().totalAmount; 

        if (doc.data().status === "Pending")
        {
          categoryTotal += doc.data().totalAmount;
        }

      });

      setPendingSalesOrdersTotalSecondTopTile(total);
      setPendingSalesOrdersSecondTopTile(categoryTotal);

    });

    const unsubscribeThirdTopTileData = onSnapshot(thirdTopTileCollection, snapshot => {
      let total = 0;
      let totalCategory = 0;

      snapshot.forEach(doc => {
        total += 1; // Aggregate count

        
      if (doc.data().status === "Active")
      {
        totalCategory = totalCategory + 1;
      }
        
      });

      setActiveStorageLocationsTotalThirdTopTile(total);

      setActiveStorageLocationsThirdTopTile(totalCategory);

    });

    const unsubscribeFourthTopTileData = onSnapshot(fourthTopTileCollection, snapshot => {
      let total = 0;
      let categoryTotal = 0;

      snapshot.forEach(doc => {
        total += doc.data().pricePerUnit; 

        if (doc.data().type === "Grain")
        {
          categoryTotal += doc.data().pricePerUnit;
        }

      });

      setGrainIngredientsTotalFourthTopTile(total);
      setGrainIngredientsFourthTopTile(categoryTotal);
    });

    
    const unsubscribeLineChartData = onSnapshot(lineChartCollection, snapshot => {
      const data = {};
      let totalSum = 0;
      snapshot.forEach(doc => {
        const { status, totalAmount } = doc.data();
        totalSum += totalAmount;

        if (status in data) {
          data[status] += totalAmount;
        } else {
          data[status] = totalAmount;
        }
      });

      setTotalLineChartSum(totalSum);

      const formattedData = Object.keys(data).map(key => ({
        x: key,
        y: data[key],
      }));

      setLineChartData([{ id: 'Status', color: '#4cceac', data: formattedData }]);
    });

    const unsubscribeBarChartData = onSnapshot(barChartCollection, snapshot => {
      const field1List =  ["Pending","Delivered","Cancelled"]  // ["Low", "Medium", "High"];                 // priorityList
      const field2List =  ["Unpaid","Paid","Overdue"]  //["Pending", "In Progress", "Completed"];   // statusList
      let data = [];

      field1List.forEach(status=> {
        let statusData = { status };
        field2List.forEach(paymentStatus => {
          statusData[paymentStatus] = 0;
          statusData[`${paymentStatus}Color`] = `hsl(${Math.floor(Math.random() * 360)}, 70%, 50%)`;
        });
        data.push(statusData);
      });

      snapshot.forEach(doc => {
        const { status, paymentStatus } = doc.data();
        const statusIndex = field1List.indexOf(status);
        if (statusIndex > -1 && field2List.includes(paymentStatus)) {
          data[statusIndex][paymentStatus]++;
        }
      });

      setBarChartData(data);
    });

    const unsubscribeRecentTransactionsData = onSnapshot(recentTransactionQuery, snapshot => {
      const transactions = snapshot.docs.map(doc => doc.data());
      setRecentTransactions(transactions);
    });

    
    const unsubscribeFunnelChartData = onSnapshot(funnelChartCollection, snapshot => {
      const data = {};
      const colors = ["#ff5733", "#3386ff", "#3cff33", "#ab0b9f"];
      let colorIndex = 0;

      snapshot.forEach((doc) => {
        const { status, totalAmount } = doc.data();
        if (data[status]) {
          data[status] += totalAmount;
        } else {
          data[status] = totalAmount;
        }
      });
      
      const formattedData = Object.keys(data)
      .map((category, index) => ({
        id: `Step ${index + 1}`,
        value: data[category],
        label: category,
        color: colors[colorIndex++ % colors.length],
      }))
      .sort((a, b) => b.value - a.value); // Sorting by value in descending order
      


      setFunnelChartData(formattedData);
    });


    // Cleanup subscriptions on unmount
    return () => {
      unsubscribeFirstTopTileData();
      unsubscribeSecondTopTileData();
      unsubscribeThirdTopTileData();
      unsubscribeFourthTopTileData();
      unsubscribeLineChartData();
      unsubscribeBarChartData();
      unsubscribeRecentTransactionsData();
      unsubscribeProgressCircleData();
      unsubscribeFunnelChartData();
  
    };
  }, [appUserAccountNumber, applicationMode]);

  return (
    <Box m="20px"
    style={{
      margin: '20px',
      backgroundImage: isMobile ? `url(${backgroundImageMobile})` : `url(${backgroundImage})`,
      backgroundRepeat: 'no-repeat',
      backgroundPosition: 'top right',
      //backgroundSize: 'contain',
      //opacity: 0.1, // Adjust the opacity as needed
    }}
  >
      {/* HEADER */}
      <Box display="flex" justifyContent="space-between" alignItems="center">
        <Header title="DASHBOARD" subtitle="Welcome to your dashboard" />

      {/*
        <Box>
          <Button
            sx={{
              backgroundColor: colors.blueAccent[700],
              color: colors.grey[100],
              fontSize: "14px",
              fontWeight: "bold",
              padding: "10px 20px",
            }}
          >
            <DownloadOutlinedIcon sx={{ mr: "10px" }} />
            Download Reports
          </Button>
        </Box>
      */}

      </Box>

      {/* GRID & CHARTS */}

       {/* ************** ROW 1 ************** */}
      <Box
        display="grid"
        gridTemplateColumns="repeat(auto-fit, minmax(200px, 1fr))"
        gridAutoRows="140px"
        gap="20px"
      >
        <Box
          backgroundColor={colors.primary[400]}
          display="flex"
          alignItems="center"
          justifyContent="center"
        >
          <StatBox
            title={outofStockProductsFirstTopTile !== null ? outofStockProductsFirstTopTile.toLocaleString() : 'Loading...'}
            subtitle="Out of Stock Products"
            progress={(outofStockProductsFirstTopTile / outofStockProductsTotalFirstTopTile).toFixed(2)}
            icon={
              <BadgeOutlinedIcon
                sx={{ color: colors.greenAccent[600], fontSize: "26px" }}
              />
            }
          />
        </Box>
       
            
        <Box
          backgroundColor={colors.primary[400]}
          display="flex"
          alignItems="center"
          justifyContent="center"
        >
          <StatBox
            title={pendingSalesOrdersSecondTopTile !== null ? pendingSalesOrdersSecondTopTile.toLocaleString("en-US", { style: "currency", currency: "USD",minimumFractionDigits: 0, maximumFractionDigits: 0 }) : 'Loading...'}
            subtitle="Pending Sales Orders Total"
            progress={(pendingSalesOrdersSecondTopTile / pendingSalesOrdersTotalSecondTopTile).toFixed(2)}
            icon={
              <PaymentsOutlinedIcon
                sx={{ color: colors.greenAccent[600], fontSize: "26px" }}
              />
            }
          />
        </Box>
        <Box
          backgroundColor={colors.primary[400]}
          display="flex"
          alignItems="center"
          justifyContent="center"
        >
          <StatBox
            title={activeStorageLocationsThirdTopTile !== null ? activeStorageLocationsThirdTopTile.toLocaleString() : 'Loading...'}
            subtitle="Active Storage Locations"
            progress={(activeStorageLocationsThirdTopTile / activeStorageLocationsTotalThirdTopTile).toFixed(2)}
            icon={
              <WalletOutlinedIcon
                sx={{ color: colors.greenAccent[600], fontSize: "26px" }}
              />
            }
          />
        </Box>
        <Box
          backgroundColor={colors.primary[400]}
          display="flex"
          alignItems="center"
          justifyContent="center"
        >

          <StatBox
            title={grainIngredientsFourthTopTile !== null ? grainIngredientsFourthTopTile.toLocaleString("en-US", { style: "currency", currency: "USD", minimumFractionDigits: 0, maximumFractionDigits: 0 }) : 'Loading...'}
            subtitle="Grain Ingredients Total"
            progress={(grainIngredientsFourthTopTile / grainIngredientsTotalFourthTopTile).toFixed(2)}
            icon={
              <BuildOutlinedIcon
                sx={{ color: colors.greenAccent[600], fontSize: "26px" }}
              />
            }
          />

        </Box>
      </Box>

      {/* ************** ROW 2 ************** */}
      <br></br>
      <Box
        display="grid"
        gridTemplateColumns={{ xs: "1fr", sm: "2fr 1fr" }}
        gap="20px"
      >
        <Box
            backgroundColor={colors.primary[400]}
            display="flex"
            flexDirection="column"
            justifyContent="space-between"
            p="20px"
          >
            <Box
              mt="25px"
              p="0 30px"
              display="flex"
              justifyContent="space-between"
              alignItems="center"
            >
              <Box>
                <Typography
                  variant="h5"
                  fontWeight="600"
                  color={colors.grey[100]}
                >
                  Sales Orders Total Amounts
                </Typography>
                <Typography
                  variant="h3"
                  fontWeight="bold"
                  color={colors.greenAccent[500]}
                >
                  {totalLineChartSum.toLocaleString("en-US", {
                    style: "currency",
                    currency: "USD",
                    minimumFractionDigits: 0, 
                    maximumFractionDigits: 0
                  })}
                </Typography>
              </Box>
              
            </Box>
            <Box height="250px" m="-20px 0 0 0">
              <LineChart data={lineChartData} isDashboard={true} />
            </Box>
        </Box>
        <Box
          backgroundColor={colors.primary[400]}
          overflow="auto"
          display="flex"
          flexDirection="column"
        >
          <Box
            display="flex"
            justifyContent="space-between"
            alignItems="center"
            borderBottom={`4px solid ${colors.primary[500]}`}
            colors={colors.grey[100]}
            p="15px"
          >
            <Typography color={colors.grey[100]} variant="h5" fontWeight="600">
            Recent Ingredients
            </Typography>
          </Box>

          <Box
            sx={{
              maxHeight: "300px",
              overflowY: "auto",
              overflowX: "hidden",
              border: `1px solid ${colors.primary[500]}`,
              borderRadius: "8px",
            }}
          >
            {recentTransactions.map((recentTransaction, i) => (
              <Box
                key={`transId-${i}`}
                display="flex"
                justifyContent="space-between"
                alignItems="center"
                borderBottom={`1px solid ${colors.primary[500]}`}
                p="15px"
              >
                <Box>
                  <Typography color={colors.greenAccent[500]} variant="h5" fontWeight="600">
                    {recentTransaction.name}
                  </Typography>
                  <Typography color={colors.grey[100]}>
                  {convertFirestoreTimestampToDateString(recentTransaction.expiryDate)}

                  </Typography>
                </Box>
                <Box backgroundColor={colors.greenAccent[500]} p="5px 10px" borderRadius="4px">
                  ${recentTransaction.pricePerUnit}
                </Box>
              </Box>
            ))}
          </Box>
        </Box>
      </Box>

      {/* ************** ROW 3 ************** */}
      <br></br>
      <Box
        display="grid"
        gridTemplateColumns={{ xs: "repeat(auto-fit, minmax(300px, 1fr))", sm: "1fr 2fr 1fr" }}
        gridAutoRows="auto"
        gap="20px"
      >
        <Box
          backgroundColor={colors.primary[400]}
          p="30px"
          display="flex"
          flexDirection="column"
          justifyContent="space-between"
        >
<Box
          backgroundColor={colors.primary[400]}
          p="30px"
          display="flex"
          flexDirection="column"
          justifyContent="space-between"
        >
          <Typography variant="h5" fontWeight="600">
            Pending Production Batches Count
          </Typography>
          <Box
            display="flex"
            flexDirection="column"
            alignItems="center"
            mt="25px"
          >
            <ProgressCircle size="125" progress={progressPercentage} />
            
            <Typography
              variant="h5"
              color={colors.greenAccent[500]}
              sx={{ mt: "15px" }}
            >
              {pendingProductionBatchesProgressCircle} of {pendingProductionBatchesTotalProgressCircle} Pending
            </Typography>
          </Box>
        </Box>
        </Box>
        <Box
          backgroundColor={colors.primary[400]}
          p="30px"
          display="flex"
          flexDirection="column"
          justifyContent="space-between"
        >
          <Typography
            variant="h5"
            fontWeight="600"
            sx={{ padding: "0 0 20px 0" }}
          >
            Sales Orders By Status and Payment Status
          </Typography>
          <Box height="250px" mt="-20px">
            <BarChart data={barChartData} isDashboard={true} />
          </Box>
        </Box>
        <Box
          backgroundColor={colors.primary[400]}
          p="30px"
          display="flex"
          flexDirection="column"
          justifyContent="space-between"
        >
          <Typography
            variant="h5"
            fontWeight="600"
            sx={{ marginBottom: "15px" }}
          >
            Sales Order Totals By Status
          </Typography>
          <Box height="200px">
            <FunnelChart isDashboard={true} data={funnelChartData}/>
          </Box>
        </Box>
      </Box>

      <br></br>

    </Box>
  );
};

export default Dashboard;